/**
 * What other modules may use from constellation. Anything not exported here is
 * constellation's own business, and importing it by deep path couples the two.
 */
export { useLaunchConstellationCoupleForSession, useLaunchConstellationForSession } from "./application/useSnapshots";
export { ConstellationAPI } from "./infrastructure/api/Constellation.api";
export { default as BoardDefaultsModal } from "./ui/components/BoardDefaultsModal";
export { default as ConstellationLaunchSheet } from "./ui/components/ConstellationLaunchSheet";
export { default as ConstellationOpenBoardModal } from "./ui/components/ConstellationOpenBoardModal";
export { default as ConstellationScenesModal } from "./ui/components/ConstellationScenesModal";
export { default as ConstellationSessionsModal } from "./ui/components/ConstellationSessionsModal";
export { default as ConstellationSnapshots } from "./ui/components/ConstellationSnapshots";
export { default as NewSessionFromBoard } from "./ui/components/NewSessionFromBoard";
export { useSessionConstellation } from "./application/useSessionConstellation";
export { openConstellationInMeeting } from "./application/meetingBoard";

/**
 * The figure manager is heavy and opened rarely, so it is handed out as a
 * loader for React.lazy rather than a component: the import stays dynamic and
 * the manager keeps its own chunk.
 */
export const loadConstellationFigureManager = () =>
    import("./ui/components/ConstellationFigureManager");
